import React from 'react';

import Loader from 'components/Loader';

const DropzoneProgress = () => {
  return (
    <div className="DropzoneProgressContainer">
      <Loader />
      <p>Uploading ...</p>
    </div>
  );
};

export default DropzoneProgress;
